import { FC } from 'react';

import ReactDatePickerComponent, { ReactDatePickerProps } from 'react-datepicker';

import classNames from 'classnames';

import { DEFAULT_FORMAT } from '@hsp/utilities';

import { DatePickerProps } from 'types/components/date-picker/date-picker.props';

import { DatePickerHeader } from './header';
import { DatePickerInput } from './input';

import './date-picker.component.scss';

const DatePicker: FC<ReactDatePickerProps & DatePickerProps> = ({
  className,
  maxDate,
  minDate,
  showFullMonthYearPicker,
  showMonthYearPicker,
  showYearPicker,
  yearItemNumber,
  ...props
}) => {
  return (
    <div className={classNames('date-picker-wrapper', className)}>
      <ReactDatePickerComponent
        {...props}
        customInput={
          <DatePickerInput
            isClearable={props.isClearable}
            onClear={props.onClear}
          />
        }
        dateFormat={DEFAULT_FORMAT}
        maxDate={maxDate}
        minDate={minDate}
        renderCustomHeader={(props) => {
          return (
            <DatePickerHeader
              {...props}
              maxDate={maxDate}
              minDate={minDate}
              showFullMonthYearPicker={showFullMonthYearPicker}
              showMonthYearPicker={showMonthYearPicker}
              showYearPicker={showYearPicker}
              yearItemNumber={yearItemNumber}
            />
          );
        }}
        showFullMonthYearPicker={showFullMonthYearPicker}
        showMonthYearPicker={showMonthYearPicker}
        showYearPicker={showYearPicker}
        yearItemNumber={yearItemNumber}
      />
    </div>
  );
};

export default DatePicker;
